import * as Yup from 'yup';

const requiredString = 'Campo requerido';
const mailString = 'Formato de mail inválido';

const UserInfoSchema = Yup.object().shape({
  firstName: Yup.string()
    .min(3, 'El nombre debe tener al menos 3 caracteres')
    .required('El nombre es un campo requerido'),
  lastName: Yup.string()
    .min(3, 'El apellido debe tener al menos 3 caracteres')
    .required('El apellido es un campo requerido'),
  email: Yup.string().email(mailString).required(requiredString),
});

const schemas = {
  UserInfoSchema,
};

export default schemas;
